import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExtraInfoCasillasCamposService } from '../../services/extra-info-casillas-campos.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { TiposContenido } from '../../models/tipos-contenido';
import { DatosTiposContenidoService } from '../../services/datos-tipos-contenido.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const PANEL_HEIGHT_ESTIMATE = 350;
const PANEL_WIDTH = 250;

@Component({
  selector: 'app-extra-info-casillas-campos',
  templateUrl: './extra-info-casillas-campos.component.html',
  styleUrls: ['./extra-info-casillas-campos.component.css']
})
export class ExtraInfoCasillasCamposComponent implements OnInit {

  // formularioCasillas: FormGroup;
  // formularioCampos: FormGroup;
  // formularioPalabras: FormGroup;
  @Input() data: any;
  @Input() anchorRect: DOMRect | { top: number; left: number; bottom: number; right: number; width: number; height: number } | null = null;
  @Input() permitirBorrado: boolean = true;
  @Output() infoExtraEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cerrarInfoExtra: EventEmitter<any> = new EventEmitter<any>();
  @Output() borrarInfoExtra: EventEmitter<any> = new EventEmitter<any>();
  mensajeErrorOrdenOpcion: string = '';
  mensajeErrorIdentificadorCampo: string = '';
  mensajeErrorValorPorDefecto: string = '';
  mensajeErrorIdentificadorPalabra: string = '';
  palabrasClave: string[] = [];

  constructor(private fb: FormBuilder,
              public extraInfoCasillasCamposService: ExtraInfoCasillasCamposService,
              private dialog: MatDialog,
              private datosTiposContenidoService: DatosTiposContenidoService,
              private _snackBar: MatSnackBar) {
                this.getTiposContenidoData();
               }

  getPanelStyle(): Record<string, string | number> {
    /*
    IMPLEMENTACION ANTERIOR (guardada por si se quiere recuperar):
    const base: Record<string, string | number> = {
      position: 'fixed',
      width: PANEL_WIDTH + 'px',
      height: PANEL_HEIGHT_ESTIMATE + 'px',
      // overflow: 'auto',
      'z-index': 901,
    };
    if (!this.anchorRect) {
      base.top = '50%';
      base.left = '50%';
      base.transform = 'translate(-50%, -50%)';
      return base;
    }
    const r = this.anchorRect;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 600;
    const vw = typeof window !== 'undefined' ? window.innerWidth : 800;
    const spaceBelow = vh - r.bottom;
    const showBelow = spaceBelow >= PANEL_HEIGHT_ESTIMATE + GAP;
    const left = Math.max(VIEWPORT_PADDING, Math.min(r.left, vw - PANEL_WIDTH - VIEWPORT_PADDING));
    base.left = left + 'px';
    if (showBelow) {
      base.top = (r.bottom + GAP) + 'px';
    } else {
      base.bottom = (vh - r.top + GAP) + 'px';
    }
    return base;
    */

    // Nueva implementacion:
    // - Vertical: siempre centrado en pantalla.
    // - Horizontal: a la derecha del elemento que abre, o a la izquierda si no cabe.
    const base: Record<string, string | number> = {
      position: 'fixed',
      width: PANEL_WIDTH + 'px',
      height: PANEL_HEIGHT_ESTIMATE + 'px',
      top: '50%',
      'z-index': 901,
    };

    if (!this.anchorRect) {
      base.left = '50%';
      base.transform = 'translate(-50%, -50%)';
      return base;
    }

    const GAP = 8;
    const VIEWPORT_PADDING = 8;
    const vw = typeof window !== 'undefined' ? window.innerWidth : 800;
    const r = this.anchorRect;

    const rightPosition = r.right + GAP;
    const leftPosition = r.left - PANEL_WIDTH - GAP;
    const canShowRight = rightPosition + PANEL_WIDTH <= vw - VIEWPORT_PADDING;

    const desiredLeft = canShowRight ? rightPosition : leftPosition;
    const safeLeft = Math.max(
      VIEWPORT_PADDING,
      Math.min(desiredLeft, vw - PANEL_WIDTH - VIEWPORT_PADDING)
    );

    base.left = safeLeft + 'px';
    base.transform = 'translateY(-50%)';
    return base;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data']){

    switch(this.data.tipoInfo){
      case 'casillas':
        this.extraInfoCasillasCamposService.inicializarFormularioCasillas(this.data);
        break;
      case 'campos':
        this.extraInfoCasillasCamposService.inicializarFormularioCampos(this.data);
        break;
      case 'palabras':
        this.extraInfoCasillasCamposService.inicializarFormularioPalabras(this.data);
        break;
      default:
        break;
    }
    }
  }

  ngOnInit(): void {
  }

    // getters para los formularios
    get ordenOpcion(){return this.extraInfoCasillasCamposService.formularioCasillas.get('ordenOpcion')}
    get valorOpcionSeleccionada(){return this.extraInfoCasillasCamposService.formularioCasillas.get('valorOpcionSeleccionada')}
    get obligatorioCasilla(){return this.extraInfoCasillasCamposService.formularioCasillas.get('obligatorio')}
    get idCasilla(){return this.extraInfoCasillasCamposService.formularioCasillas.get('id')}
    // getters para los campos
    get identificadorCampo(){return this.extraInfoCasillasCamposService.formularioCampos.get('identificadorCampo')}
    get nombreCampo(){return this.extraInfoCasillasCamposService.formularioCampos.get('nombreCampo')}
    get valorPorDefecto(){return this.extraInfoCasillasCamposService.formularioCampos.get('valorPorDefecto')}
    get obligatorioCampo(){return this.extraInfoCasillasCamposService.formularioCampos.get('obligatorio')}
    get idCampo(){return this.extraInfoCasillasCamposService.formularioCampos.get('id')}
    // getters para las palabras
    get identificadorPalabra(){return this.extraInfoCasillasCamposService.formularioPalabras.get('identificadorPalabra')}
    get nombrePalabra(){return this.extraInfoCasillasCamposService.formularioPalabras.get('nombrePalabra')}
    get idPalabra(){return this.extraInfoCasillasCamposService.formularioPalabras.get('id')}

  getFormByTipo(tipo: string): FormGroup {
    switch(tipo){
      case 'casillas':
        return this.extraInfoCasillasCamposService.formularioCasillas;
      case 'campos':
        return this.extraInfoCasillasCamposService.formularioCampos;
      case 'palabras':
        return this.extraInfoCasillasCamposService.formularioPalabras;
      default:
        return new FormGroup({});
    }
  }

  guardarInfoExtra(){
    const form = this.getFormByTipo(this.data.tipoInfo);
    form.markAllAsTouched();
    if (form.invalid) {
      return;
    }
    this.infoExtraEmitter.emit({tipo: this.data.tipoInfo, data: form.value});
    this.cerrar();
  }

  cerrar(){
    this.cerrarInfoExtra.emit();
  }

  getControl(campo: string, tipo: string) {
    return this.getFormByTipo(tipo).get(campo);
  }

  isCampoValido(campo:string, tipo:string){
    const control = this.getControl(campo, tipo);
    if (!control) return false;

    switch (campo) {
      case 'ordenOpcion':
        if(control.errors?.ordenOpcionRequired){
          this.mensajeErrorOrdenOpcion = 'El orden de la opción es requerido.';
        }
        if(control.errors?.ordenOpcionDuplicado){
          this.mensajeErrorOrdenOpcion = 'El orden de la opción no puede estar duplicado.';
        }
        break;
      case 'identificadorCampo':
        if(control.errors?.identificadorVacio){
          this.mensajeErrorIdentificadorCampo = 'El identificador del campo es requerido.'
        }
        if(control.errors?.identificadorExiste){
          this.mensajeErrorIdentificadorCampo = 'El identificador del campo ya existe, no puede ser duplicado.'
        }
        break;
      // case 'valorPorDefecto':
      //   if(control.errors?.tiposContenidoNoValido){
      //     this.mensajeErrorValorPorDefecto = 'El valor por defecto tiene que ser un tipo de contenido válido.'
      //   }
      //   break;
      case 'identificadorPalabra':
        if(control.errors?.identificadorPalabraVacio){
          this.mensajeErrorIdentificadorPalabra = 'El identificador de la palabra es requerido.'
        }
        if(control.errors?.identificadorPalabraExiste){
          this.mensajeErrorIdentificadorPalabra = 'El identificador de la palabra ya existe, no puede ser duplicado.'
        }
        break;

    }
    // if(this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo]){
    //     return this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo].errors && this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo].touched;
    //   }else{
    //     return true;
    //   }
    return control.errors && control.touched;
  }

  borrarCasilla(){
    if (!this.permitirBorrado){
      this.dialog.open(ModalMessageComponent, {
        data: {
          mensaje: `Para borrar la casilla debe estar en el apartado de "Casillas de verificación".`,
          alert: true
        },
      });
      return;
    }
    this.borrarInfoExtra.emit({tipo: this.data.tipoInfo, id: this.data.id});
    this.cerrar();
  }

  getTiposContenidoData(){
    this.datosTiposContenidoService.getTiposContenido().subscribe(
      next => {
        this.palabrasClave = next.map(item => item.nombre);
        this.palabrasClave.unshift(' ');
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  seleccionarValorPorDefecto(event: string | { desc?: string }): void {
    const raw = typeof event === 'string' ? event : (event?.desc ?? '');
    const vacio = raw === ' ' || raw === '' || (typeof raw === 'string' && raw.trim() === '');
    this.valorPorDefecto?.setValue(vacio ? '' : raw);
  }
}
